import { render, staticRenderFns } from "./LicenseGroupList.vue?vue&type=template&id=72326db0&"
import script from "./LicenseGroupList.vue?vue&type=script&lang=js&"
export * from "./LicenseGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports